import TranslationsTable from 'components/Translations/TranslationsTable';
import useActions from 'hooks/useActions';
import { useEffect } from 'react';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        question: state.CSQuestions.selectedQuestion,
        translations: state.CSQuestions.translations,
        page: state.CSQuestions.translations_page,
        per_page: state.CSQuestions.translations_per_page,
        total: state.CSQuestions.translations_total,
        total_pages: state.CSQuestions.translations_total_pages,
        isLoading: state.CSQuestions.translations_is_loading,
        selectedTranslation: state.CSQuestions.selectedTranslation,
    };
}

const CSQuestionTranslations = connect(mapStateToProps)(function (props) {
    const {
        question,
        translations,
        page,
        per_page,
        total,
        total_pages,
        isLoading,
        selectedTranslation,
    } = props;

    const {
        CS_FETCH_QUESTION_TRANSLATIONS_REQUEST,
        CS_POST_QUESTION_TRANSLATION_REQUEST,
        CS_UPDATE_QUESTION_TRANSLATION_REQUEST,
        CS_DELETE_QUESTION_TRANSLATION_REQUEST,
        CS_SELECT_QUESTION_TRANSLATION,
    } = useActions();

    function onNext() {
        CS_FETCH_QUESTION_TRANSLATIONS_REQUEST({
            questionId: question?.id,
            page: page + 1,
            per_page,
        });
    }

    function onPrev() {
        CS_FETCH_QUESTION_TRANSLATIONS_REQUEST({
            questionId: question?.id,
            page: page - 1,
            per_page,
        });
    }

    function onPageSelected(selectedPage) {
        CS_FETCH_QUESTION_TRANSLATIONS_REQUEST({
            questionId: question?.id,
            page: selectedPage,
            per_page,
        });
    }

    function onPerPageSelected({ perPage }) {
        CS_FETCH_QUESTION_TRANSLATIONS_REQUEST({
            questionId: question?.id,
            per_page: perPage,
        });
    }

    function onDelete(translation) {
        CS_DELETE_QUESTION_TRANSLATION_REQUEST({
            questionId: question?.id,
            page,
            per_page,
            translationId: translation.id,
        });
    }

    function onUpdate(translation) {
        CS_UPDATE_QUESTION_TRANSLATION_REQUEST(translation);
    }

    function onCreate(translation) {
        CS_POST_QUESTION_TRANSLATION_REQUEST({
            resourceId: question.id,
            translation,
        });
    }

    useEffect(() => {
        CS_FETCH_QUESTION_TRANSLATIONS_REQUEST({
            questionId: question?.id,
        });
        return () => {
            CS_SELECT_QUESTION_TRANSLATION(null);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <TranslationsTable
            page={page}
            perPage={per_page}
            onNext={onNext}
            onPrev={onPrev}
            onPageSelected={onPageSelected}
            onPerPageSelected={onPerPageSelected}
            isLoading={isLoading}
            total={total}
            totalPages={total_pages}
            onDelete={onDelete}
            translations={translations}
            onSelect={CS_SELECT_QUESTION_TRANSLATION}
            onCreate={onCreate}
            onUpdate={onUpdate}
            selectedTranslation={selectedTranslation}
        />
    );
});

export default CSQuestionTranslations;
